import React, { useState, useEffect, useRef, useContext } from 'react';
import { TrendingUp, ChevronDown } from 'lucide-react';
import { UserSettingsContext } from '../../../context/UserSettingsContext';


const Metrics = ({ metricsList, id, title, value, unit = '', trend, trendUnit, vs, onMetricChange, existingMetrics }) => {
  const [isSelectOpen, setIsSelectOpen] = useState(false);
  const [showCategoryColumns, setShowCategoryColumns] = useState(false);
  const [selectedMetrics, setSelectedMetrics] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const ref = useRef(null);

  const categorySelected = (category) => {
    const categoryMetrics = metricsList.find((metric) => metric.category === category);
    setSelectedCategory(category);
    setSelectedMetrics(categoryMetrics ? categoryMetrics.metrics : []);
    setShowCategoryColumns(true);
  };

  const handleMetricSelected = (category, newMetric) => {
    onMetricChange(id, category, newMetric);
    setIsSelectOpen(false);
  };

  // 外部クリックで閉じるためのイベントリスナー
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (ref.current && !ref.current.contains(event.target)) {
        setIsSelectOpen(false);
      }
    };

    if (isSelectOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    } else {
      document.removeEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isSelectOpen]);

  return (
    <div ref={ref} className={`metric-box-small cursor-move relative ${isSelectOpen ? "front-display" : ""}`}>
      <div className="metric-label cursor-move flex items-center justify-center">
        <span>{title}</span>
      </div>
      <div className="metric-value">
        <span className="value">{value}</span>
        <span className="unit">{unit}</span>
        <div
          className="absolute top-2 right-2 cursor-pointer text-white"
          onClick={() => setIsSelectOpen(!isSelectOpen)}
        >
          <ChevronDown className="w-4 h-4" />
        </div>
        {isSelectOpen && (
          <div className="absolute top-8 right-2 bg-white border rounded shadow-md flex">
            <div className="">
              {metricsList.map((metric) => (
                <div
                  key={metric.category}
                  className="px-4 py-2 hover:bg-gray-100 cursor-pointer text-sm"
                  onClick={() => categorySelected(metric.category)}
                >
                  {metric.category}
                </div>
              ))}
            </div>
            {showCategoryColumns && (
                <div className="bg-gray-50 border-l p-4">
                    {selectedMetrics.map((metric) => {
                        const isExisting = existingMetrics.includes(metric.metric); 

                        return (
                            <div 
                                key={metric.metric} 
                                className={`py-1 text-sm cursor-pointer ${isExisting ? 'text-gray-400 cursor-not-allowed' : ''}`} 
                                onClick={() => !isExisting && handleMetricSelected(selectedCategory, metric.metric)}
                            >
                                {metric.metric_name}
                            </div>
                        );
                    })}
                </div>
            )}
          </div>
        )}
      </div>
      {trend !== undefined && trend !== '-' && trend !== '前期マイナス' && trend  ? (
        <div
          className={`flex items-center justify-center text-sm border-t py-1 ${
            trend >= 0 ? 'text-green-500' : 'text-red-500'
          }`}
        >
            <TrendingUp className={`w-4 h-4 mr-1 ${trend < 0 ? 'scale-y-[-1]' : ''}`} />
            <span>{Math.abs(trend)}{trendUnit} ({vs})</span>
        </div>
      ) : (
        <div
          className={`flex items-center justify-center text-sm border-t py-1 text-gray-500 `}
        >
          <span>{trend}</span>
        </div>
      )}
    </div>
  );
};

export default Metrics;
